import React from 'react';
import CallMadeIcon from '@material-ui/icons/CallMade';
import routesPath from 'config/routesPath';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ButtonBase from '@material-ui/core/ButtonBase';
import { BannerNotificationContainer, Title, Action } from './styles';

const BannerNotification = () => {
  const history = useHistory();

  const { currentDealer } = useSelector(state => state.dealerStore);
  const { userType } = useSelector(state => state.userStore);

  if (
    !currentDealer?.overdueBill ||
    window.location.pathname.includes('minhas-revendas') ||
    window.location.pathname.includes('group-view') ||
    window.location.pathname.includes('callcenter') ||
    window.location.pathname.includes('busca-e-resgate') ||
    !['OWNER', 'DIRECTOR', 'SALES_MANAGER', 'FINANCIAL'].includes(userType)
  ) {
    return null;
  }

  if (currentDealer?.overdueBill) {
    return (
      <BannerNotificationContainer overdueBill={currentDealer?.overdueBill}>
        <Title>
          Fatura vencida: ainda não recebemos a confirmação do pagamento da sua
          fatura.
        </Title>
        <ButtonBase
          onClick={() =>
            history.push(routesPath.getRecursivePath(routesPath.billings))
          }
        >
          <Action>
            <CallMadeIcon color="inherit" fontSize="small" />
            Ir para minhas faturas
          </Action>
        </ButtonBase>
      </BannerNotificationContainer>
    );
  }

  // if(currentDealer?.nearDueBill){
  //   return(
  // <BannerNotificationContainer>

  //             <MessageBannerNotification>
  //               Fatura próxima do vencimento: esteja atento para não deixar
  //               sua fatura vencer.
  //             </MessageBannerNotification>

  //             <MessageBannerNotificationSecond
  //               onClick={() =>
  //                 history.push(
  //                   routesPath.getRecursivePath(routesPath.billings)
  //                 )
  //               }
  //             >
  //               <CallMadeIcon color="inherit" fontSize="small" />
  //             </MessageBannerNotificationSecond>
  //             <MessageBannerNotificationThird
  //               onClick={() =>
  //                 history.push(
  //                   routesPath.getRecursivePath(routesPath.billings)
  //                 )
  //               }
  //             >
  //               {' '}
  //               Ir para minhas faturas{' '}
  //             </MessageBannerNotificationThird>

  //       </BannerNotificationContainer>
  //   )

  // }
};

export default BannerNotification;
